module.exports = __webpack_public_path__ + "static/media/ix-ambientworks.728d304.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ambient-works/ix-ambientworks.mp3
// module id = Wm7j
// module chunks = 0